








































































import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faBackspace,
  faPencilAlt,
  faThumbsDown as filledThumbsDown,
  faThumbsUp as filledThumbsUp
} from '@fortawesome/free-solid-svg-icons'
import {
  faCommentAlt,
  faThumbsDown,
  faThumbsUp
} from '@fortawesome/free-regular-svg-icons'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'TagPopup',
  components: {
    FontAwesomeIcon
  },
  props: {
    isAnalysis: {
      default: false
    },
    tag: {
      required: true
    }
  },
  setup() {
    return {
      filledThumbsUp: filledThumbsUp,
      filledThumbsDown: filledThumbsDown,
      thumbsDown: faThumbsDown,
      thumbsUp: faThumbsUp,
      commentAlt: faCommentAlt,
      pencilAlt: faPencilAlt,
      backspace: faBackspace
    }
  }
})
